import React from 'react';
import { Box, HStack, Text, Image, Center } from '@chakra-ui/react';
import bio_image from './Melissa@2x.png';
import { biomel as bio } from '../../copy';

export const BioMel = () => {
	return (
		<Center className='bio-mel-center'>
			<HStack className='bio-mel-hstack'>
				<Box className='bio-mel-img-box'>
					<Center>
						<Image src={bio_image} className='bio-mel-img' />
					</Center>
				</Box>
				<Box className='bio-mel-box'>
					<Center>
						<Box className='bio-mel-copy'>
							<Text className='bio-mel-headline'>{bio.headline}</Text>
							<Text className='bio-mel-subhead'>{bio.subhead}</Text>
							<Text className='bio-mel-body'>{bio.copy}</Text>
						</Box>
					</Center>
				</Box>
			</HStack>
		</Center>
	);
};
